export default "__VITE_ASSET__DJGNqop2__"